import Vue from 'vue'
import VueRouter from 'vue-router'
import GameZL from '../views/GameZL.vue'
import OrderQuery from '../views/OrderQuery.vue'
import GameSelect from '../views/GameSelect.vue'
import WarOrder from '../components/WarOrder.vue'

Vue.use(VueRouter)

// 各路由差异化 TDK; 未配置 meta 的路由回退到构建期注入的默认值
const routes = [
  {
    path: '/',
    name: 'WarOrder',
    component: WarOrder
  },
  {
    path: '/warzone',
    name: 'Warzone',
    component: WarOrder,
    meta: {
      title: '王者荣耀改战区-在线荣耀战区更改|电竞助手',
      description: '王者荣耀在线改战区系统，一键修改荣耀战区定位，配合最低战力查询快速拿省标、市标、县标，支持全平台在线下单。'
    }
  },
  {
    path: '/warzone/query',
    name: 'OrderQuery',
    component: OrderQuery,
    meta: {
      title: '改战区订单查询-王者荣耀战区更改进度|电竞助手',
      description: '查询王者荣耀改战区订单进度，输入订单号即可实时查看战区修改状态。'
    }
  },
  {
    // 注意: 必须在 /warzone/:orderNo 之前注册, 否则会被动态路由吞掉
    path: '/warzone/games',
    name: 'GameSelect',
    component: GameSelect,
    meta: {
      title: '游戏服务选择-改战区/战力查询支持游戏列表|电竞助手',
      description: '电竞助手支持的游戏服务列表：王者荣耀改战区、荣耀战力查询等，按游戏选择所需服务在线下单。'
    }
  },
  {
    path: '/warzone/:orderNo',
    name: 'WarzoneOrder',
    component: WarOrder,
    props: true
  },
  {
    path: '/zl',
    name: 'GameZL',
    component: GameZL,
    meta: {
      title: '王者荣耀最低战力查询-荣耀战力排行在线免费查询|电竞助手',
      description: '免费在线查询王者荣耀全英雄最低战力战区，支持安卓QQ/苹果QQ/安卓微信/苹果微信，覆盖全国省市区县实时数据，轻松拿省标。'
    }
  },
  {
    path: '/czl',
    name: 'GameCZL',
    component: GameZL,
    meta: {
      title: '王者荣耀最低战力查询-荣耀战力排行在线免费查询|电竞助手',
      description: '免费在线查询王者荣耀全英雄最低战力战区，支持安卓QQ/苹果QQ/安卓微信/苹果微信，覆盖全国省市区县实时数据，轻松拿省标。'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  // 注意: 不能用 process.env.BASE_URL(即 publicPath=/html/warzone/)。
  // publicPath 是静态资源目录, 而路由表里的路径已自带 /warzone 前缀且由后端映射,
  // 两者若绑定会拼出 /html/warzone/warzone/games 这种重复路径。
  base: '/',
  routes
})

// SEO: 路由切换时更新 title / description / canonical (SPA 客户端渲染兜底)
const DEFAULT_TITLE = document.title
const DEFAULT_DESC = document.querySelector('meta[name="description"]')?.getAttribute('content') || ''
router.afterEach(to => {
  document.title = to.meta?.title || DEFAULT_TITLE
  const desc = document.querySelector('meta[name="description"]')
  if (desc) desc.setAttribute('content', to.meta?.description || DEFAULT_DESC)
  const canonical = document.querySelector('link[rel="canonical"]')
  if (canonical) canonical.setAttribute('href', 'https://yxsaoma.com' + to.path)
})

export default router 